import { filter } from '../../stores/filter';
import { jobs } from '../../stores/store';
import { get } from 'svelte/store';
import { SettingsApi } from '../components/Settings/SettingsApi';
import { type localStorageFilterType } from '../components/telematics/components/FilterByParameters/FilterManager';
import { api } from '../../stores/api';
import { z } from 'zod';
import { features } from '../shared/Features/features';

export const resetFilterQuery = () => {
    // alert('Aby problem się nie powtórzył usuniemy zawartość filtrów');
    console.debug('resetFilterQuery: ', get(filter).jobsToBeCompleted.managerStorageKey);
    filter.update(f => {
        f.jobsToBeCompleted.queries = {};
        f.jobsToBeCompleted.quickSearch = '';
        return f;
    });

    let data: localStorageFilterType = {
        mainFilterData: {
            queries: {},
            related: [],
        },
        lastUsedFilterData: {
            queries: {},
            related: [],
            historyOfAddedKeys: [],
        },
        __inactiveQueriesKeys: [],
        __andOrSelection: 'and',
    };
    SettingsApi.setClientSettings<localStorageFilterType>(
        get(api),
        get(filter).jobsToBeCompleted.managerStorageKey || '',
        data,
        z.any()
    );
};

export const getCountFilterQuery = () => {
    let outputQueries: any = {};
    if (get(features).feature_ux_improvements) {
        let quickFilterQueries = getQuickFilterQueries();
        if (quickFilterQueries.length) {
            outputQueries['$and'] = quickFilterQueries;
        }
    } else {
        let showOnlyToDo = get(jobs).showOnlyToDo;
        if (showOnlyToDo) {
            outputQueries['$and'] = [{ process_stage: { $lt: 20 }, completed_as_planned: null }]; // not assigned
        }
    }
    return { ...outputQueries };
};

const getQuickSearchQueries = (quickSearch: string, queries: any) => {
    let or = [];
    if (typeof queries['computed_address.city'] === 'undefined') {
        or.push({
            'computed_address.city': {
                $ilike: '%' + quickSearch + '%',
            },
        });
    }
    if (typeof queries['computed_address.street'] === 'undefined') {
        or.push({
            'computed_address.street': {
                $ilike: '%' + quickSearch + '%',
            },
        });
    }
    if (typeof queries['computed_address.house'] === 'undefined') {
        or.push({
            'computed_address.house': {
                $ilike: '%' + quickSearch + '%',
            },
        });
    }
    if (typeof queries['computed_address.pcode'] === 'undefined') {
        or.push({
            'computed_address.pcode': {
                $ilike: '%' + quickSearch + '%',
            },
        });
    }
    /*if (typeof queries['client_attributes.waybill'] === 'undefined') {
        // https://er.automapa.pl/issues/44473
        or.push({
            'client_attributes.waybill': {
                $ilike: '%' + quickSearch + '%',
            },
        });
    }
    if (typeof (queries['client_attributes'] as Record<string, any>)?.['ID paczki'] === 'undefined') {
        // https://er.automapa.pl/issues/44473
        or.push({
            'client_attributes.ID paczki': {
                $ilike: '%' + quickSearch + '%',
            },
        });
    }*/
    if (typeof (queries['special_attributes'] as Record<string, any>)?.['external_id'] === 'undefined') {
        // https://er.automapa.pl/issues/44650
        or.push({
            'special_attributes.external_id': {
                $ilike: '%' + quickSearch + '%',
            },
        });
    }
    return or;
}

const getQuickFilterQueries = () => {
    let queries = [];
    let quickFilters = get(jobs).quickFilters?.filters || [];
    for (let i = 0; i < quickFilters.length; i++) {
        if (quickFilters[i].active) {
            queries.push(quickFilters[i].filter)
        }
    }
    return queries;
}

export const getFilterQuery = () => {
    let queries = { ...get(filter).jobsToBeCompleted.queries };
    let quickSearch = get(filter).jobsToBeCompleted.quickSearch;

    let quickSearchQueries: any = [];

    if (quickSearch !== '') {
        quickSearchQueries = getQuickSearchQueries(quickSearch, queries);
    }

    let subQueries = [];
    if (Object.keys(queries).length) {
        subQueries.push(queries);
    }
    if (quickSearchQueries.length) {
        subQueries.push({$or: quickSearchQueries});
    }
    if (get(features).feature_ux_improvements) {
        subQueries = subQueries.concat(getQuickFilterQueries());
    } else {
        let onlyLowQualityAddresses = get(filter).jobsToBeCompleted.onlyLowQuality;
        if (onlyLowQualityAddresses) {
            subQueries.push({coords_accepted: false});
        }
        let showOnlyToDo = get(jobs).showOnlyToDo;
        if (showOnlyToDo) {
            subQueries.push({ process_stage: { $lt: 20 }, completed_as_planned: null });
        }
    }

    return subQueries.length ? {$and: subQueries} : {};
};
